import React from 'react';
const paths = {
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  external: <><path d="M14 3h7v7M21 3l-11 11" /><path d="M10 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5" /></>,
  copy: <><rect x="8" y="8" width="12" height="13" rx="2" /><path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  menu: <path d="M4 6h16M4 12h16M4 18h16" />,
  close: <path d="m6 6 12 12M6 18 18 6" />,
  token: <><circle cx="12" cy="12" r="9" /><path d="M15 8h-4a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9m3-10v12" /></>,
  chart: <path d="M4 3v17h17M7 15l4-5 4 3 6-8" />,
  lock: <><rect x="5" y="10" width="14" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" /></>,
  shield: <><path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z" /><path d="m8 12 3 3 5-6" /></>,
  game: <><path d="M7 7h10c4 0 6 12 3 12-2 0-4-4-5-4H9c-1 0-3 4-5 4-3 0-1-12 3-12Z" /><path d="M7 10v4m-2-2h4m7-1h.01M18 13h.01" /></>,
  people: <><circle cx="9" cy="8" r="3" /><path d="M3 21v-3a6 6 0 0 1 12 0v3m1-16a3 3 0 0 1 0 6m2 4a5 5 0 0 1 3 4v2" /></>,
  wallet: <><path d="M20 8V5H5a2 2 0 0 0 0 4h16v12H5a2 2 0 0 1-2-2V7" /><path d="M21 13h-5v4h5" /></>,
  x: <path d="m4 3 12 18h4L8 3H4Zm0 18 7-8m2-2 7-8" />,
  telegram: <><path d="m21 3-4 18-6-5-4 3 1-7L3 10 21 3Z" /><path d="m8 12 9-6-6 10" /></>,
  tiktok: <path d="M14 3v12a5 5 0 1 1-5-5m5-7c0 4 3 6 6 6V6c-2 0-3-1-3-3h-3Z" />,
  pause: <path d="M8 5v14M16 5v14" />,
  play: <path d="m8 4 12 8-12 8V4Z" />,
};
export default function Icon({ name, className = '' }) {
  return <svg className={`icon ${className}`} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{paths[name] || paths.arrow}</svg>;
}
